import { SearchCriteriaModel } from 'stores/models/search-criteria-model';

export const getRewardsFilterInput = (searchCriteria: SearchCriteriaModel): string[] | null =>
  (searchCriteria.rewards && searchCriteria.rewards.length > 0) ? searchCriteria.rewards : null;
